import { Injectable } from '@angular/core';
import { first, map, mergeMap, switchMap, takeUntil, tap } from 'rxjs/operators';
import { BehaviorSubject, EMPTY, from, Observable, of, Subscriber } from 'rxjs';

import { ConfigService } from 'src/app/shared/services/config.service';
import { SortService } from 'src/app/shared/services/sort.service';
import { StorageService } from './storage.service';

//import { SharedModule } from '../shared.module';
import { Itinerary } from '../models/itinerary.interface';



const _log: boolean = false;

@Injectable()//{providedIn: SharedModule}
export class ItineraryService {

	private _itinerary: Itinerary = null;
	private _itinerary_Source = new BehaviorSubject<Itinerary>(null);
	public itinerary$ = this._itinerary_Source.asObservable();

	constructor(
		private _configService: ConfigService,
		private _sortService: SortService,
		private _storageService: StorageService,
	){
		//console.log('ItineraryService.constructor');
	}


	public getItinerary(){
		if(_log) console.log('ItineraryService.getItinerary()', this._itinerary);

		if(!this._itinerary) {
			this._itinerary = this._storageService.getItinerary();
		}
		return this._itinerary;
	}

	public setItinerary(itinerary: Itinerary){
		if(_log) console.log('ItineraryService.setItinerary()', itinerary);
		this._itinerary = itinerary;
		this._itinerary_Source.next(this._itinerary);
		this._storageService.setItinerary(this._itinerary);
	}

	public clearItinerary(){
		if(_log) console.log('ItineraryService.clearItinerary()');
		this._itinerary = null;//this.getItineraryDefault();
		this._itinerary_Source.next(this._itinerary);
		this._storageService.unSetItinerary();
		return this._itinerary;
	}

}